import React from "react";
import Info from "../img/info";

export default () => (
  <div className="fav__only-logged-in">
    <div className="fav__info">
      <Info />
    </div>
    <div className="fav__only-logged-in-content">
      <p>Tämä toiminto on vain kirjautuneille käyttäjille</p>
      <a href="/wp-admin">
        <p>Kirjaudu täältä →</p>
      </a>
      <a href="/rekisteroidy">
        <p>Rekisteröidy →</p>
      </a>
    </div>
  </div>
);
